export default "__VITE_ASSET__f8f80acb__"